import { LucidePersonStanding } from "lucide-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useMetaPixel } from "../hooks/useMetaPixel";

const LandingPage = () => {
  const { trackEvent } = useMetaPixel();
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/login");
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.innerHTML = `
      var head = document.head;
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = "https://213502.t.hyros.com/v1/lst/universal-script?ph=8037809a1b4fa13f47ce2be500afd8cdb7b5cdce93d6ab85b86324c2b73106b0&tag=!clicked&ref_url=" + encodeURI(document.URL) ;
      head.appendChild(script);
    `;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);
  
  return (
    <LucidePersonStanding />
  )

};

export default LandingPage;